export default function OptionPic({ pics, k, big }) {
  if (!pics || !pics[k]) return null;
  return (
    <img src={`${process.env.REACT_APP_BACKEND_URL}/api/option-image/${pics[k]}`} alt="" loading="lazy" draggable={false}
      className={`${big ? "w-20 h-20 sm:w-24 sm:h-24" : "w-16 h-16"} rounded-xl bg-white border-2 border-slate-200 object-contain shrink-0`}
      data-testid={`option-pic-${k}`} />
  );
}
